/**
 * Frontend mirror of PitchBook.Core AgeGroups.Ladder — youngest first, Open last.
 * Keep in step with the backend ladder; it drives dropdowns and age-ordered lists.
 */
export const AGE_GROUPS = [
  'U5',
  'U6',
  'U7',
  'U8',
  'U9',
  'U10',
  'U11',
  'U12',
  'U13',
  'U14',
  'U15',
  'U16',
  'U17',
  'U18',
  'Open',
];

/** Ladder position for sorting; unknown groups sort last. */
export function ageGroupIndex(ageGroup: string): number {
  const i = AGE_GROUPS.indexOf(ageGroup);
  return i < 0 ? Number.MAX_SAFE_INTEGER : i;
}
